import * as React from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import styles from './Toggle.module.scss';

// Interfaces
// //////////////////////////

export interface Props extends React.HTMLAttributes<HTMLElement> {
  name: string;
  label?: string;
  value: string;
  checked?: boolean;
  disabled?: boolean;
  size?: 'md' | 'lg';
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

/**
 * <Toggle> component
 */
export const Toggle: React.FunctionComponent<Props> = ({
  id,
  className,
  name,
  label,
  value,
  checked,
  disabled,
  size = 'md',
  onChange,
  ...htmlElementProps
}) => {
  const inputId = id ?? uuid();
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={classNames(styles.toggle, className, {
        disabled,
        [size]: size,
      })}
      title={label}
      {...htmlElementProps}
    >
      <input
        id={inputId}
        type="checkbox"
        className={styles.checkbox}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className={styles.slider} />
    </label>
  );
};

export default Toggle;
